import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

type OnzaNormal = '11' | '15' | '17';
type OnzaColor = '11' | '15';  // Quitamos la onza '17' para taza color
type OnzaMagica = '11' | '15' | '17';

@Component({
  selector: 'app-articulospromocionales',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './articulospromocionales.component.html',
  styleUrls: ['./articulospromocionales.component.css']
})
export class ArticulospromocionalesComponent {

  // Onzas para cada tipo
  onzasNormales: OnzaNormal[] = ['11', '15', '17'];
  onzasColor: OnzaColor[] = ['11', '15'];
  onzasMagicas: OnzaMagica[] = ['11', '15', '17'];

  // Selecciones independientes
  onzaNormalSeleccionada: OnzaNormal | null = null;
  onzaColorSeleccionada: OnzaColor | null = null;
  onzaMagicaSeleccionada: OnzaMagica | null = null;

  // Precios independientes
  preciosNormales: Record<OnzaNormal, number> = {
    '11': 60,
    '15': 80,
    '17': 100
  };

  preciosColor: Record<OnzaColor, number> = {
    '11': 80,
    '15': 100
  };

  preciosMagica: Record<OnzaMagica, number> = {
    '11': 80,
    '15': 100,
    '17': 120
  };

  // Métodos para taza normal
  seleccionarNormal(onza: OnzaNormal) {
    this.onzaNormalSeleccionada = onza;
  }

  obtenerImagenNormal(): string {
    return this.onzaNormalSeleccionada
      ? `assets/imgProductospromocionales/taza_normal_${this.onzaNormalSeleccionada}_oz.png`
      : '';
  }

  obtenerPrecioNormal(): number | null {
    return this.onzaNormalSeleccionada
      ? this.preciosNormales[this.onzaNormalSeleccionada]
      : null;
  }

  // Métodos para taza color
  seleccionarColor(onza: OnzaColor) {
    this.onzaColorSeleccionada = onza;
  }

  obtenerImagenColor(): string {
    return this.onzaColorSeleccionada
      ? `assets/imgProductospromocionales/taza_color_${this.onzaColorSeleccionada}_oz.png`
      : '';
  }

  obtenerPrecioColor(): number | null {
    return this.onzaColorSeleccionada
      ? this.preciosColor[this.onzaColorSeleccionada]
      : null;
  }

  // Métodos para taza mágica
  seleccionarMagica(onza: OnzaMagica) {
    this.onzaMagicaSeleccionada = onza;
  }

  obtenerImagenMagica(): string {
    return this.onzaMagicaSeleccionada
      ? `assets/imgProductospromocionales/taza_magica_${this.onzaMagicaSeleccionada}_oz.png`
      : '';
  }

  obtenerPrecioMagica(): number | null {
    return this.onzaMagicaSeleccionada
      ? this.preciosMagica[this.onzaMagicaSeleccionada]
      : null;
  }
}
